/* Recordings and dates, Cohorts and dates, registers and Webinars (stage 5), from AdminRecordings.dc.html
   and AdminWebinars.dc.html. Master brand only, every colour a token (styles/tokens.css); small grey
   text never lighter than --shell-ink-60 (the boards' 0.55 and 0.45 greys are 0.6 here). Under 760px
   the 2 columns become 1 and rows stack (Adam, 4 Oct, answer 5). */

/* ---- The list and the editor -------------------------------------------------------------------- */
.adc-rec, .adc-web { display: grid; grid-template-columns: 360px minmax(0, 1fr); gap: 24px; align-items: start; }
.adc-web { grid-template-columns: 340px minmax(0, 1fr); }
.adc-web-side { display: flex; flex-direction: column; gap: 12px; min-width: 0; }

/* The list scrolls in its own box (Adam, 13 Oct), so the editor beside it stays put: sticky beside the
   editor on a laptop, at most 60% of the screen where they stack. No overscroll-behavior: at the end of
   the list the page carries on, so its lower part is never trapped below the fold. Each product's heading
   is pinned at the top of the box, opaque (the same 3% tint, white where color-mix isn't known). */
.adc-list {
  border-radius: 14px; border: 1px solid var(--shell-ink-10); overflow-y: auto; position: relative; scroll-padding-top: 48px;
  background: var(--shell-bg);
}
.adc-rec > .adc-list { position: sticky; top: 24px; max-height: calc(100vh - 48px); }
.adc-group-head {
  position: sticky; top: 0; z-index: 1;
  padding: 12px 16px; background: var(--shell-bg); background: color-mix(in srgb, var(--shell-ink) 3%, var(--shell-bg));
  border-bottom: 1px solid var(--shell-ink-08);
  display: flex; align-items: center; gap: 8px; font-size: 12px; font-weight: 800; letter-spacing: 0.06em;
  text-transform: uppercase; color: var(--shell-ink-62);
}
/* Recordings' headings fold their product away (Adam, 13 Oct): a 44px button with a chevron */
.adc-group-fold {
  width: 100%; min-height: 44px; border: 0; border-bottom: 1px solid var(--shell-ink-08); margin: 0;
  font-family: inherit; line-height: 1.35; text-align: left; cursor: pointer;
}
.adc-group-fold:hover { background: color-mix(in srgb, var(--shell-ink) 6%, var(--shell-bg)); }
.adc-group-name { min-width: 0; overflow-wrap: anywhere; }
.adc-group-chev { margin-left: auto; transition: transform 0.15s; }
.adc-group-fold[aria-expanded="false"] .adc-group-chev { transform: rotate(-90deg); }
.adc-group:last-child > .adc-group-fold[aria-expanded="false"] { border-bottom: none; }
/* the focus ring inside the box, where the box can't clip it */
.adc-list .adc-item:focus-visible, .adc-list .adc-group-head:focus-visible { outline-offset: -2px; }
.adc-item {
  width: 100%; display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 12px 16px;
  border: none; border-bottom: 1px solid var(--shell-ink-06); border-left: 3px solid transparent;
  background: var(--shell-bg); color: var(--shell-ink); text-align: left; font: inherit; cursor: pointer;
}
.adc-item:hover { background: var(--shell-ink-03); }
.adc-item[aria-current="true"] { background: var(--shell-ink-04); border-left-color: var(--shell-gold); }
.adc-group:last-child .adc-item:last-child { border-bottom: none; }
.adc-item--web { align-items: flex-start; }
.adc-item-text { display: flex; flex-direction: column; gap: 1px; min-width: 0; }
.adc-item-name { font-size: 14px; font-weight: 700; line-height: 1.35; overflow-wrap: anywhere; }
.adc-item-name--web { display: flex; align-items: center; gap: 7px; }
.adc-item-sub { font-size: 12px; color: var(--shell-ink-60); }
.adc-item-count { flex-shrink: 0; font-size: 12px; font-weight: 800; color: var(--shell-ink-66); }
/* a webinar's thumbnail, small, where any webinar has 1 (Adam, 9 Oct) */
.adc-item-thumb {
  flex-shrink: 0; width: 56px; aspect-ratio: 16 / 9; border-radius: 4px; overflow: hidden; background: var(--shell-ink-06);
  margin-top: 2px;
}
.adc-item-thumb img { display: block; width: 100%; height: 100%; object-fit: cover; }
.adc-item-thumb + .adc-item-text { margin-right: auto; }
/* a recording with its own thumbnail: a small grey mark beside its chip (Adam, 13 Oct) */
.adc-rec .adc-item-text { margin-right: auto; }
.adc-item-pic { flex-shrink: 0; display: inline-flex; color: var(--shell-ink-60); }

/* A recording's chip: Live, Tonight, After the session, Draft */
.adc-chip {
  flex-shrink: 0; height: 22px; padding: 0 8px; border-radius: 11px; border: 1px solid var(--shell-ink-30);
  background: var(--shell-bg); color: var(--shell-ink); font-size: 11px; font-weight: 800; display: inline-flex; align-items: center; white-space: nowrap;
}
.adc-chip--live { background: var(--shell-ink-07); border-color: var(--shell-ink-07); }
.adc-chip--tonight { border-color: var(--shell-ink); }
.adc-chip--after { border-color: var(--shell-ink-14); }
.adc-chip--big { height: 26px; padding: 0 10px; border-radius: 13px; font-size: 12px; }
.adc-chip--web { border-color: var(--shell-ink-30); background: var(--shell-bg); }

.adc-editor { padding: 24px 26px; display: flex; flex-direction: column; gap: 16px; min-width: 0; }
.adc-editor-wrap { min-width: 0; scroll-margin-top: 24px; }
/* overflow: hidden (.ad-card) would make the card a scroll box, and the pinned foot would never stick */
.ad-card.adc-editor { overflow: clip; }
.adc-editor-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; }
.adc-editor-title { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
.adc-eyebrow { font-size: 12px; font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase; color: var(--shell-ink-60); }
.adc-h2 { margin: 0; font-size: 22px; font-weight: 800; line-height: 1.25; overflow-wrap: anywhere; }
.adc-editor .ad-label--plain, .adc-field-label { font-size: 13px; font-weight: 800; color: var(--shell-ink); letter-spacing: 0; text-transform: none; }
.adc-editor .ad-input { font-weight: 500; }
.adc-editor .ad-textarea { font-weight: 500; resize: vertical; }
/* the boards' 13px chapters and homework (admin.css gives every other box 14px). A phone keeps 16px,
   so it doesn't zoom in on a box */
@media (min-width: 761px) {
  .adc-chapters, .adc-homework { font-size: 13px; }
}
.adc-link-note { margin: -8px 0 0; font-size: 13px; line-height: 1.5; color: var(--shell-ink-60); overflow-wrap: anywhere; }
.adc-link-note--bad { color: var(--shell-ink); }
.adc-length { max-width: 220px; }
.adc-two { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 16px; }
.adc-one { display: grid; grid-template-columns: minmax(0, 1fr); gap: 16px; }
.adc-chapters { min-height: 190px; line-height: 1.6; font-variant-numeric: tabular-nums; }
.adc-homework { min-height: 110px; }
.adc-preview-wrap { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.adc-preview {
  height: 190px; overflow-y: auto; border-radius: 9px; background: var(--shell-ink-03); padding: 10px 12px;
  display: flex; flex-direction: column; gap: 6px;
}
.adc-preview-line { display: flex; gap: 10px; font-size: 13px; line-height: 1.45; }
.adc-preview-time { min-width: 56px; font-weight: 800; font-variant-numeric: tabular-nums; flex-shrink: 0; }
.adc-preview-empty { font-size: 13px; line-height: 1.5; color: var(--shell-ink-60); }
.adc-count { font-size: 12px; color: var(--shell-ink-60); min-height: 18px; }
.adc-files-tags { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.adc-tags { margin-top: 4px; }
.adc-tags .ad-input { height: 40px; font-size: 13px; }
.adc-dashed {
  height: 42px; border-radius: 9px; border: 1px dashed var(--shell-ink-30); background: var(--shell-bg); color: var(--shell-ink);
  font: inherit; font-weight: 700; font-size: 13px; cursor: pointer; padding: 0 12px;
}
.adc-dashed--tall { border-radius: 10px; font-size: 14px; }
.adc-dashed:disabled { opacity: 0.55; cursor: default; }
.adc-file-input { position: absolute; width: 1px; height: 1px; opacity: 0; pointer-events: none; }
.adc-quiet { font-size: 13px; line-height: 1.5; color: var(--shell-ink-62); }
.adc-foot {
  display: flex; align-items: center; justify-content: space-between; gap: 12px 16px; padding-top: 14px;
  border-top: 1px solid var(--shell-ink-08); flex-wrap: wrap;
}
.adc-foot--end { justify-content: flex-end; }
.adc-foot--start { justify-content: flex-start; }
.adc-foot-actions { display: flex; gap: 10px; flex-wrap: wrap; }
.adc-foot .ad-check { flex: 1 1 240px; min-width: 0; }
.adc-foot .ad-btn { height: 44px; padding: 0 20px; }
.adc-btn-live { background: var(--shell-ink-30); color: var(--shell-on-ink); border-color: transparent; }
.adc-btn-live:disabled { opacity: 1; }
/* Switch it off's question, under the foot (Adam, 5 Oct, question 5) */
.adc-confirm-wrap { margin-top: 14px; }
.adc-flash { margin: 0; font-size: 14px; font-weight: 700; line-height: 1.5; }
/* a new on-demand course's Add module, at the foot of its group, and a new product's first intake card
   (the product-types plan, 13 Oct) */
.adc-add-module { display: flex; flex-wrap: wrap; align-items: center; gap: 8px 12px; padding: 10px 14px 14px; }
.adc-cohort--first .adc-first-line { margin: 0; padding: 0 20px; font-size: 14px; line-height: 1.5; color: var(--shell-ink-66); }
/* The editor's foot, pinned to the bottom of the screen while any of the editor shows (Adam, 13 Oct),
   with Switch it off's question, any problem and the saved line in it, in that order. Where sticky
   isn't known it sits where the foot always did. A field above it reached with Tab scrolls clear of it
   (a margin on the fields, not the page's scroll-padding, which would scroll the page for the pinned
   buttons themselves). */
.adc-dock {
  position: sticky; bottom: 0; z-index: 2; display: flex; flex-direction: column; gap: 12px;
  margin: 0 -26px -24px; padding: 14px 26px 18px; background: var(--shell-bg); border-top: 1px solid var(--shell-ink-08);
}
.adc-dock .adc-foot { border-top: 0; padding-top: 0; }
.adc-dock .adc-confirm-wrap { margin-top: 0; }
.adc-editor > :not(.adc-dock) :is(input, textarea, select, button, a, [tabindex]) { scroll-margin-bottom: 96px; }
.adc-hint { font-size: 12px; line-height: 1.5; color: var(--shell-ink-60); }
.adc-pad { padding: 16px 22px; }
.adc-break { overflow-wrap: anywhere; }

/* Vimeo's player, out of sight, while it gives a video's title and length */
.adc-vimeo-read { position: fixed; left: -10000px; top: 0; width: 320px; height: 180px; border: 0; opacity: 0; pointer-events: none; }

/* ---- Cohorts and dates --------------------------------------------------------------------------- */
.adc-cards { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 22px; align-items: start; }
.adc-cohort-head {
  padding: 16px 20px; display: flex; justify-content: space-between; align-items: flex-start; gap: 12px;
  border-bottom: 1px solid var(--shell-ink-08);
}
.adc-cohort-names { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.adc-cohort-product {
  display: flex; align-items: center; gap: 8px; font-size: 12px; font-weight: 800; letter-spacing: 0.06em;
  text-transform: uppercase; color: var(--shell-ink-60);
}
.adc-cohort-name { font-size: 17px; font-weight: 800; }
.adc-cohort-pattern { font-size: 13px; color: var(--shell-ink-60); text-align: right; }
.adc-row {
  display: grid; grid-template-columns: 70px minmax(0, 1fr) 70px 136px; gap: 10px; align-items: center; padding: 10px 20px;
  border: none; border-bottom: 1px solid var(--shell-ink-05); font: inherit; font-size: 13px; color: var(--shell-ink);
  background: var(--shell-bg); width: 100%; text-align: left; text-decoration: none;
}
.adc-row--link { cursor: pointer; }
.adc-row--link:hover, .adc-row--link[aria-expanded="true"] { background: var(--shell-ink-03); }
.adc-row-label { font-weight: 800; }
.adc-row-time { color: var(--shell-ink-60); }
.adc-row-state { justify-self: end; font-weight: 700; text-align: right; }
.adc-row-state--held, .adc-row-state--cancelled { color: var(--shell-ink-60); }
.adc-row-state--zoomSet { color: var(--shell-ink-72); }
.adc-row-state--setDate, .adc-row-state--noZoom { color: var(--shell-ink); }
/* a held row's register, with the arrow that says it opens (the Accelerator critique's admin 7) */
.adc-row-state--held { display: inline-flex; align-items: center; gap: 6px; }
.adc-row-state--todo { color: var(--shell-ink); }
.adc-row-go { flex-shrink: 0; color: var(--shell-ink-60); }
.adc-zoomfill-link { font-size: 13px; overflow-wrap: anywhere; }
.adc-zoomfill-btn.ad-btn { white-space: normal; height: auto; min-height: 36px; padding-top: 8px; padding-bottom: 8px; line-height: 1.3; text-align: left; }
.adc-wa {
  margin: 12px 20px 0; padding: 12px 14px; border-radius: 9px; background: var(--shell-ink-03);
  display: flex; flex-direction: column; gap: 8px;
}
.adc-wa-label { font-size: 12px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; color: var(--shell-ink-60); }
.adc-wa-row { display: flex; gap: 8px; align-items: center; }
.adc-wa .adc-wa-input { height: 36px; border-radius: 8px; font-size: 13px; padding: 0 10px; }
.adc-wa-note { font-size: 12px; line-height: 1.5; color: var(--shell-ink-60); }
/* Profit On Your Terms's deal surgery switch, per intake */
.adc-surgery {
  margin: 12px 20px 0; padding: 12px 14px; border-radius: 9px; background: var(--shell-ink-03);
  display: flex; flex-direction: column; gap: 8px;
}
.adc-surgery-row { display: flex; gap: 12px; align-items: center; justify-content: space-between; }
.adc-cohort-foot { padding: 12px 20px; display: flex; gap: 8px 12px; align-items: center; flex-wrap: wrap; }
.adc-footnote { margin: 0; font-size: 13px; line-height: 1.55; color: var(--shell-ink-60); max-width: 900px; }

/* The session box, under the row it changes */
.adc-sbox {
  margin: 0 12px 12px; padding: 14px 16px; border-radius: 10px; background: var(--shell-ink-03); border: 1px solid var(--shell-ink-08);
  display: flex; flex-direction: column; gap: 12px;
}
.adc-sbox-title { font-size: 14px; font-weight: 800; }
.adc-sbox-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
.adc-sbox .ad-label--plain { font-size: 13px; font-weight: 800; }
.adc-sbox-foot { display: flex; gap: 8px 12px; align-items: center; flex-wrap: wrap; }

/* ---- Registers ----------------------------------------------------------------------------------- */
.adc-reg-lede { margin: 0; padding: 16px 22px 4px; font-size: 14px; line-height: 1.55; color: var(--shell-ink-72); }
.adc-reg-count { font-weight: 700; color: var(--shell-ink); }
.adc-reg { list-style: none; margin: 0; padding: 0; }
.adc-reg-line {
  display: grid; grid-template-columns: minmax(0, 1.1fr) minmax(0, 1.3fr) minmax(0, 1fr); gap: 8px 16px; align-items: center;
  padding: 14px 22px; border-bottom: 1px solid var(--shell-ink-06);
}
.adc-reg-line:last-child { border-bottom: none; }
.adc-reg-who { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.adc-reg-name { font-size: 15px; font-weight: 700; }
.adc-reg-email { font-size: 13px; color: var(--shell-ink-60); overflow-wrap: anywhere; }
.adc-reg-tags { display: flex; gap: 6px; flex-wrap: wrap; }
.adc-reg-tags:empty { display: none; }
.adc-reg-mark { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.adc-reg-mark .ad-options--row .ad-option { flex: 1 1 0; min-width: 0; height: 36px; }
/* the Accelerator critique's admin 3 (20 Oct): Excused's hint under its name, and the picked mark solid, so a
   register can be scanned. Scoped here: admin.css's .ad-option is every Options control in admin. */
.adc-reg-mark .ad-options--row .ad-option { flex-direction: column; justify-content: center; gap: 0; height: auto; min-height: 36px; padding: 4px 8px; }
.adc-reg-mark .ad-option-note { font-size: 11px; line-height: 1.25; text-align: center; }
.adc-reg-mark .ad-option[aria-checked="true"] { background: var(--shell-ink); border-color: var(--shell-ink); color: var(--shell-on-ink); }
.adc-reg-mark .ad-option[aria-checked="true"] .ad-option-note { color: var(--on-dark-80); }
/* a name on a mastermind's register opens them in Masterminds */
/* a mastermind member's name opens them in Masterminds: underlined, as Masterminds' own names are, since a phone has no
   hover to show it's a link */
.adc-reg-name--link {
  color: var(--shell-ink); text-decoration: underline; text-underline-offset: 3px; align-self: flex-start; display: inline-flex;
  align-items: center; min-height: 24px;
}
.adc-reg-name--link:hover { text-decoration-thickness: 2px; }
/* an absence's caught-up day, under the line */
.adc-reg-catch { grid-column: 1 / -1; display: flex; flex-wrap: wrap; align-items: flex-end; gap: 8px 12px; }
.adc-reg-catch .ad-field { min-width: 0; flex: 0 1 240px; }
.adc-reg-catch .ad-label--plain { font-size: 13px; font-weight: 800; }
.adc-reg-catch-acts { display: flex; gap: 8px; padding-bottom: 4px; }
.adc-reg-catch > .ad-error, .adc-reg-catch > .adc-flash { flex-basis: 100%; }
.adc-reg-by { font-size: 12px; color: var(--shell-ink-60); }
.adc-reg-note .ad-input { height: 38px; }
.adc-reg-problem { grid-column: 1 / -1; }

/* ---- Webinars ------------------------------------------------------------------------------------ */
.adc-side-note { font-size: 12px; line-height: 1.5; color: var(--shell-ink-60); }
.adc-zoom { display: flex; flex-direction: column; gap: 4px; padding: 14px 16px; border-radius: 10px; border: 1px solid var(--shell-ink-10); }
.adc-zoom-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding-bottom: 6px; flex-wrap: wrap; }
.adc-zoom-title { font-size: 12px; font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase; color: var(--shell-ink-60); }
.adc-zoom-note { font-size: 12px; color: var(--shell-ink-60); }
.adc-zoom-rows { margin: 0; }
.adc-zoom-row {
  display: grid; grid-template-columns: 150px minmax(0, 1fr); gap: 12px; padding: 8px 0;
  border-top: 1px solid var(--shell-ink-06); font-size: 14px;
}
.adc-zoom-row dt { font-weight: 800; }
.adc-zoom-row dd { margin: 0; line-height: 1.5; color: var(--shell-ink-80); min-width: 0; }
/* the box's rows typed by hand (stage 6): the board's label column, with the box beside it */
.adc-details { display: flex; flex-direction: column; }
.adc-detail.ad-field {
  display: grid; grid-template-columns: 150px minmax(0, 1fr); column-gap: 12px; row-gap: 4px; align-items: center;
  padding: 8px 0; border-top: 1px solid var(--shell-ink-06);
}
.adc-detail .ad-label { grid-column: 1; font-size: 14px; font-weight: 800; }
.adc-detail > :not(.ad-label) { grid-column: 2; }
.adc-detail--top.ad-field { align-items: start; }
.adc-detail--top .ad-label { padding-top: 10px; }
.adc-detail .ad-textarea { min-height: 64px; }
.adc-detail-text { font-size: 14px; line-height: 1.5; color: var(--shell-ink-80); }
.adc-showrow {
  display: flex; align-items: center; justify-content: space-between; gap: 20px; padding: 14px 16px; border-radius: 12px;
  border: 1px solid var(--shell-ink-12); background: transparent; color: var(--shell-ink); text-align: left; font: inherit; cursor: pointer; width: 100%;
}
.adc-showrow:disabled { cursor: default; }
.adc-showrow-text { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
.adc-showrow-title { font-size: 15px; font-weight: 700; }
.adc-showrow-note { font-size: 13px; line-height: 1.5; color: var(--shell-ink-60); }
.adc-track { width: 48px; height: 28px; border-radius: 14px; background: var(--shell-ink-20); position: relative; flex-shrink: 0; }
.adc-knob { position: absolute; top: 3px; left: 3px; width: 22px; height: 22px; border-radius: 11px; background: var(--shell-bg); transition: left 0.15s; }
.adc-showrow[aria-checked="true"] .adc-track { background: var(--shell-ink); }
.adc-showrow[aria-checked="true"] .adc-knob { left: 23px; }
/* A webinar's thumbnail (Adam, 9 Oct): the 16:9 preview as members see it, and its buttons */
.adc-thumb { display: flex; flex-direction: column; gap: 8px; }
.adc-thumb-row { display: flex; align-items: flex-start; gap: 16px; }
/* the preview, and under it the line when the saved 1 won't load */
.adc-thumb-pic { display: flex; flex-direction: column; gap: 8px; flex-shrink: 0; width: 240px; }
.adc-thumb-frame {
  position: relative; flex-shrink: 0; width: 240px; aspect-ratio: 16 / 9; border-radius: 10px; overflow: hidden;
  border: 1px solid var(--shell-ink-10); background: var(--shell-ink-04); display: flex; align-items: center; justify-content: center;
}
.adc-thumb-frame img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; display: block; }
.adc-thumb-date { display: flex; flex-direction: column; align-items: center; gap: 2px; }
.adc-thumb-edge { font-size: 12px; font-weight: 700; letter-spacing: 0.1em; color: var(--shell-ink-60); }
.adc-thumb-day { font-size: 30px; font-weight: 800; line-height: 1.1; }
.adc-thumb-side { display: flex; flex-direction: column; gap: 8px; min-width: 0; }
.adc-thumb-buttons { display: flex; gap: 8px; flex-wrap: wrap; }
.adc-thumb-warn, .adc-thumb-note, .adc-thumb-broken { margin: 0; font-size: 13px; font-weight: 700; line-height: 1.5; color: var(--shell-ink); }
/* Property Cashflow For Life's own module panel where a recording has no thumbnail (Adam, 12 Oct), as its
   cards draw it: the course's dark green, with ondemand.css's mark and corner label inside */
.adc-thumb-frame--module { background: var(--pcfl-green-deep); border-color: transparent; font-family: var(--acc-body-font); }
.adc-file { position: absolute; width: 1px; height: 1px; opacity: 0; pointer-events: none; overflow: hidden; }

/* Shown while still to come with no registration link (Adam, 5 Oct, stage 6's batch, question 2) */
.adc-show { display: flex; flex-direction: column; gap: 8px; }
.adc-show-warn { margin: 0; padding: 0 16px; font-size: 13px; font-weight: 700; line-height: 1.5; color: var(--shell-ink); }
.adc-sells { display: flex; flex-direction: column; gap: 8px; }
.adc-sell-chips { display: flex; gap: 6px; flex-wrap: wrap; }
.adc-sell {
  height: 32px; padding: 0 12px; border-radius: 16px; border: 1.5px solid var(--shell-ink-14); background: var(--shell-bg);
  color: var(--shell-ink); font: inherit; font-size: 13px; font-weight: 700; display: inline-flex; align-items: center; gap: 7px; cursor: pointer;
}
.adc-sell[aria-checked="true"] { border-color: var(--shell-ink); background: var(--shell-ink-05); }
.adc-sell:disabled { cursor: default; }
.adc-replay { display: flex; flex-direction: column; gap: 8px; padding: 16px; border-radius: 10px; background: var(--shell-ink-03); }
.adc-replay .ad-input, .adc-replay .ad-textarea { background: var(--shell-bg); }
.adc-replay .adc-link-note { margin: 0; }
.adc-replay-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.adc-replay-note { font-size: 13px; line-height: 1.5; color: var(--shell-ink-70); }
.adc-tiles { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
.adc-tile { padding: 14px 16px; border-radius: 10px; border: 1px solid var(--shell-ink-10); display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.adc-tile-label { font-size: 12px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; color: var(--shell-ink-60); }
.adc-tile-value { font-size: 24px; font-weight: 800; }
.adc-tile-note { font-size: 12px; color: var(--shell-ink-60); }
.adc-web-editor .adc-foot { padding-top: 4px; }
.adc-web-editor .adc-foot > * { margin-top: 12px; }
.adc-web-editor .adc-dock .adc-foot { padding-top: 0; }
.adc-web-editor .adc-dock .adc-foot > * { margin-top: 0; }
/* A replay's register page (docs/replay-register-spec.md 5): the link with the hub's address in front, the full
   address and Copy, the name in MailerLite and the switch, in the replay box's grey panel; then Registrations (n).
   The list of who registered is a card with the admin table, which stacks into cards on a phone */
.adc-rr { display: flex; flex-direction: column; gap: 12px; padding: 16px; border-radius: 10px; background: var(--shell-ink-03); }
.adc-rr .ad-input { background: var(--shell-bg); }
.adc-rr-head { display: flex; flex-direction: column; gap: 4px; }
.adc-rr-slug { display: flex; align-items: center; gap: 0; min-width: 0; }
.adc-rr-prefix {
  flex-shrink: 0; height: 42px; display: inline-flex; align-items: center; padding: 0 2px 0 12px; border: 1px solid var(--shell-ink-16);
  border-right: none; border-radius: 9px 0 0 9px; background: var(--shell-ink-04); font-size: 14px; color: var(--shell-ink-70);
}
.adc-rr-slug .ad-input { border-radius: 0 9px 9px 0; min-width: 0; flex: 1 1 auto; }
.adc-rr-address { display: flex; flex-direction: column; gap: 6px; }
.adc-rr-address-label { font-size: 13px; font-weight: 800; }
.adc-rr-address-row { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
.adc-rr-link { font-size: 14px; font-weight: 600; color: var(--shell-ink); }
.adc-rr-switch { display: flex; flex-direction: column; gap: 8px; }
.adc-rr .adc-show-warn { padding: 0; }
.adc-rr-foot { display: flex; gap: 8px; flex-wrap: wrap; }
.adc-nowrap { white-space: nowrap; }
.adc-rr-list-head { align-items: flex-start; }
.adc-rr-list-text { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.adc-rr-count { margin: 0; padding: 12px 20px 4px; font-size: 14px; color: var(--shell-ink-70); }
.adc-rr-name, .adc-rr-when { display: flex; flex-direction: column; align-items: flex-start; gap: 4px; min-width: 0; }
/* a short first name ("Jo") is still a 24px target */
.adc-rr-name a.ad-td-main { min-width: 24px; min-height: 24px; display: inline-flex; align-items: center; }
.adc-rr-owns { display: flex; flex-wrap: wrap; gap: 6px; }

/* Webinars' side column stays beside the editor on a laptop, its list scrolling in its own box with Add a
   webinar and its note under it (Adam, 13 Oct) */
@media (min-width: 981px) {
  .adc-web-side { position: sticky; top: 24px; max-height: calc(100vh - 48px); }
  .adc-web-side .adc-list { min-height: 0; }
  .adc-web-side > :not(.adc-list) { flex-shrink: 0; }
}

/* ---- Between laptop and phone ---------------------------------------------------------------------- */
@media (max-width: 1180px) {
  .adc-rec, .adc-web { grid-template-columns: 300px minmax(0, 1fr); gap: 18px; }
  .adc-two { grid-template-columns: minmax(0, 1fr); }
  .adc-preview { height: auto; max-height: 190px; }
  .adc-cards { grid-template-columns: minmax(0, 1fr); }
  .adc-reg-line { grid-template-columns: minmax(0, 1fr) minmax(0, 1.3fr); }
  .adc-reg-note { grid-column: 1 / -1; }
}
@media (max-width: 980px) {
  .adc-rec, .adc-web { grid-template-columns: minmax(0, 1fr); }
  .adc-rec > .adc-list { position: relative; top: auto; max-height: 60vh; }
  .adc-web-side .adc-list { max-height: 60vh; }
}

/* ---- Phone ----------------------------------------------------------------------------------------- */
@media (max-width: 760px) {
  .adc-editor { padding: 18px 16px; gap: 14px; }
  /* under the phone's 56px top bar */
  .adc-editor-wrap { scroll-margin-top: 72px; }
  .adc-editor-head { flex-direction: column-reverse; gap: 8px; }
  .adc-h2 { font-size: 20px; }
  .adc-chapters { min-height: 150px; }
  .adc-length { max-width: none; }
  .adc-foot { flex-direction: column; align-items: stretch; }
  /* In a column the row's 240px basis would become a height */
  .adc-foot .ad-check { flex: none; }
  .adc-foot-actions { flex-direction: column; }
  .adc-foot-actions .ad-btn, .adc-foot--end .ad-btn, .adc-foot--start .ad-btn { width: 100%; }
  /* pinned, the buttons sit side by side, so the foot stays about 64px tall over the phone's screen */
  .adc-dock { margin: 0 -16px -18px; padding: 10px 16px calc(10px + env(safe-area-inset-bottom)); gap: 10px; }
  .adc-dock .adc-foot, .adc-dock .adc-foot-actions { flex-direction: row; flex-wrap: wrap; align-items: center; }
  .adc-dock .adc-foot-actions { width: 100%; gap: 8px; }
  .adc-dock .adc-foot { gap: 8px; }
  .adc-dock .adc-foot .ad-btn { flex: 1 1 auto; width: auto; padding: 0 12px; white-space: nowrap; }
  .adc-dock .adc-foot > .adc-flash { flex-basis: 100%; }
  .adc-cohort-head { padding: 14px 16px; flex-direction: column; gap: 4px; }
  .adc-cohort-pattern { text-align: left; }
  .adc-row { grid-template-columns: 64px minmax(0, 1fr) auto; padding: 10px 16px; row-gap: 2px; }
  .adc-row-time { grid-column: 2; grid-row: 2; }
  .adc-row-state { grid-column: 3; grid-row: 1 / span 2; }
  .adc-wa { margin: 12px 16px 0; }
  .adc-wa .adc-wa-input { font-size: 16px; }
  .adc-wa-row { flex-direction: column; align-items: stretch; }
  .adc-cohort-foot { padding: 12px 16px; }
  .adc-sbox { margin: 0 8px 10px; padding: 12px; }
  .adc-sbox-grid { grid-template-columns: minmax(0, 1fr); }
  .adc-reg-lede { padding: 14px 16px 4px; }
  .adc-reg-line { grid-template-columns: minmax(0, 1fr); padding: 14px 16px; }
  .adc-reg-note { grid-column: auto; }
  .adc-zoom-row { grid-template-columns: minmax(0, 1fr); gap: 2px; }
  .adc-detail.ad-field { grid-template-columns: minmax(0, 1fr); row-gap: 6px; }
  .adc-detail .ad-label, .adc-detail > :not(.ad-label) { grid-column: 1; }
  .adc-detail--top .ad-label { padding-top: 0; }
  .adc-showrow { gap: 14px; }
  .adc-thumb-row { flex-direction: column; align-items: stretch; }
  .adc-thumb-pic, .adc-thumb-frame { width: 100%; }
  .adc-thumb-buttons .ad-btn { flex: 1 1 0; }
  .adc-replay { padding: 14px 12px; }
  .adc-rr { padding: 14px 12px; }
  .adc-rr-slug { flex-direction: column; align-items: stretch; }
  .adc-rr-prefix { border-right: 1px solid var(--shell-ink-16); border-bottom: none; border-radius: 9px 9px 0 0; padding: 0 12px; height: 34px; }
  .adc-rr-slug .ad-input { border-radius: 0 0 9px 9px; }
  .adc-rr-count { padding: 12px 16px 4px; }
  .adc-replay-row { flex-direction: column; align-items: stretch; }
  .adc-tiles { grid-template-columns: minmax(0, 1fr); }
  .adc-tile { flex-direction: row; flex-wrap: wrap; align-items: baseline; column-gap: 12px; }
  .adc-tile-value { font-size: 20px; order: 2; margin-left: auto; }
  .adc-tile-note { flex-basis: 100%; order: 3; }
}

/* Webinars' side column: the link to the property strategy tool's completions (Stage 2) */
.adc-strategy-link { margin-top: 16px; align-self: flex-start; }
